import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var AccessLevel;
(function (AccessLevel) {
    AccessLevel["CREATE"] = "CREATE";
    AccessLevel["MODIFY"] = "MODIFY";
    AccessLevel["READ_ONLY"] = "READ_ONLY";
})(AccessLevel || (AccessLevel = {}));
export var PermissionType;
(function (PermissionType) {
    PermissionType["ANONYMOUS"] = "ANONYMOUS";
    PermissionType["AGENCY"] = "AGENCY";
    PermissionType["PUBLISHER"] = "PUBLISHER";
    PermissionType["ACCESS_COMPLIANCE"] = "ACCESS_COMPLIANCE";
    PermissionType["ADMIN_INVOICE"] = "ADMIN_INVOICE";
    PermissionType["ANALYTICS_TOOL"] = "ANALYTICS_TOOL";
    PermissionType["ADSERVER_CREATIVES"] = "ADSERVER_CREATIVES";
    PermissionType["BOOK_CAMPAIGNS"] = "BOOK_CAMPAIGNS";
    PermissionType["VIEW_CAMPAIGNS"] = "VIEW_CAMPAIGNS";
    PermissionType["CONFIGURE_ADS_TXT"] = "CONFIGURE_ADS_TXT";
    PermissionType["CREATIVES_CRAWLER"] = "CREATIVES_CRAWLER";
    PermissionType["CREDIT_CARD_PAYMENT_ONLY"] = "CREDIT_CARD_PAYMENT_ONLY";
    PermissionType["EXCLUDE_CREATIVE_APPROVAL"] = "EXCLUDE_CREATIVE_APPROVAL";
    PermissionType["UPDATE_PERMITTED_DIGITAL_CREATIVES"] = "UPDATE_PERMITTED_DIGITAL_CREATIVES";
    PermissionType["HEADER_TAG"] = "HEADER_TAG";
    PermissionType["MANAGE_ACCOUNTS"] = "MANAGE_ACCOUNTS";
    PermissionType["MANAGE_CAMPAIGN_TYPES"] = "MANAGE_CAMPAIGN_TYPES";
    PermissionType["MANAGE_DIGITAL_CREATIVES"] = "MANAGE_DIGITAL_CREATIVES";
    PermissionType["MANAGE_DIGITAL_PRODUCTS"] = "MANAGE_DIGITAL_PRODUCTS";
    PermissionType["MANAGE_POS_PRODUCTS"] = "MANAGE_POS_PRODUCTS";
    PermissionType["MANAGE_PRINT_CREATIVES"] = "MANAGE_PRINT_CREATIVES";
    PermissionType["MANAGE_PRINT_PRODUCTS"] = "MANAGE_PRINT_PRODUCTS";
    PermissionType["MANAGE_RADIO_PRODUCTS"] = "MANAGE_RADIO_PRODUCTS";
    PermissionType["MANAGE_TV_PRODUCTS"] = "MANAGE_TV_PRODUCTS";
    PermissionType["MANAGE_CONSULTING_PRODUCTS"] = "MANAGE_CONSULTING_PRODUCTS";
    PermissionType["SYNC_DIGITAL_PRODUCTS"] = "SYNC_DIGITAL_PRODUCTS";
    PermissionType["EARLY_PAYMENT_COMMISSION"] = "EARLY_PAYMENT_COMMISSION";
    PermissionType["OPS_CHECKS"] = "OPS_CHECKS";
    PermissionType["OPS_PUSH"] = "OPS_PUSH";
    PermissionType["OPS_REPORTING"] = "OPS_REPORTING";
    PermissionType["OPS_SCREENSHOTS"] = "OPS_SCREENSHOTS";
    PermissionType["POSTADMANAGER"] = "POSTADMANAGER";
    PermissionType["POSTAL_INVOICES"] = "POSTAL_INVOICES";
    PermissionType["POSTNETZ"] = "POSTNETZ";
    PermissionType["POSTNETZ_BRANCH_USER"] = "POSTNETZ_BRANCH_USER";
    PermissionType["READ_ONLY_POSTNETZ_BRANCH_USER"] = "READ_ONLY_POSTNETZ_BRANCH_USER";
    PermissionType["PRINT_OPS_PUSH"] = "PRINT_OPS_PUSH";
    PermissionType["PAYOUT"] = "PAYOUT";
    PermissionType["PAYMENTS"] = "PAYMENTS";
    PermissionType["REPORT_BUILDER"] = "REPORT_BUILDER";
    PermissionType["SALESFUNNEL"] = "SALESFUNNEL";
    PermissionType["SELF_BOOKING"] = "SELF_BOOKING";
    PermissionType["YALEO_SELF_BOOKING"] = "YALEO_SELF_BOOKING";
    PermissionType["SEMANTIQ"] = "SEMANTIQ";
    PermissionType["TRAFFIC_DASHBOARD_ACCESS"] = "TRAFFIC_DASHBOARD_ACCESS";
    PermissionType["YALEO"] = "YALEO";
    PermissionType["MANAGE_COOP_WEEK"] = "MANAGE_COOP_WEEK";
    PermissionType["SWITCH_COMPANY_VIEW"] = "SWITCH_COMPANY_VIEW";
    PermissionType["SUPPORT_CENTER"] = "SUPPORT_CENTER";
    PermissionType["MANAGE_REFERENCE_PER_AD_MEDIA"] = "MANAGE_REFERENCE_PER_AD_MEDIA";
    PermissionType["SSO"] = "SSO";
    PermissionType["STAGE_PERFORMANCE"] = "STAGE_PERFORMANCE";
    PermissionType["TARGET_ALL_WEBSITES"] = "TARGET_ALL_WEBSITES";
    PermissionType["SPECIAL_DISCOUNTS"] = "SPECIAL_DISCOUNTS";
    PermissionType["XANDR_SEGMENTS"] = "XANDR_SEGMENTS";
    PermissionType["ADDITIONAL_TAX"] = "ADDITIONAL_TAX";
    PermissionType["EMAIL_SYNC"] = "EMAIL_SYNC";
    PermissionType["BTA_FEED_REPORT_BUILDER"] = "BTA_FEED_REPORT_BUILDER";
    PermissionType["LOCKED_FIELDS"] = "LOCKED_FIELDS";
    PermissionType["GEN_AI"] = "GEN_AI";
    PermissionType["PROGRAMMATIC_DEALS"] = "PROGRAMMATIC_DEALS";
})(PermissionType || (PermissionType = {}));
export var EntityType;
(function (EntityType) {
    EntityType["COMPANY"] = "COMPANY";
    EntityType["USER"] = "USER";
    EntityType["CAMPAIGN_TYPE"] = "CAMPAIGN_TYPE";
    EntityType["ACCOUNT"] = "ACCOUNT";
    EntityType["INDUSTRY"] = "INDUSTRY";
    EntityType["CONTACT"] = "CONTACT";
    EntityType["WEBSITE"] = "WEBSITE";
    EntityType["CAMPAIGN"] = "CAMPAIGN";
    EntityType["POST_CAMPAIGN"] = "POST_CAMPAIGN";
    EntityType["POST_ACCOUNT"] = "POST_ACCOUNT";
    EntityType["POST_CONTACT"] = "POST_CONTACT";
    EntityType["POST_INDUSTRY"] = "POST_INDUSTRY";
    EntityType["PRICE_LIST"] = "PRICE_LIST";
    EntityType["CAMPAIGN_SUB_GROUP"] = "CAMPAIGN_SUB_GROUP";
    EntityType["POSITION_SUB_GROUP"] = "POSITION_SUB_GROUP";
    EntityType["CAMPAIGN_POSITION"] = "CAMPAIGN_POSITION";
    EntityType["DIGITAL_CAMPAIGN_POSITION"] = "DIGITAL_CAMPAIGN_POSITION";
    EntityType["DIGITAL_AD_MEDIUM"] = "DIGITAL_AD_MEDIUM";
    EntityType["DIGITAL_AD_MEDIUM_MAPPING"] = "DIGITAL_AD_MEDIUM_MAPPING";
    EntityType["DIGITAL_PUBLISHER_SHARE"] = "DIGITAL_PUBLISHER_SHARE";
    EntityType["DIGITAL_AD_PRICE"] = "DIGITAL_AD_PRICE";
    EntityType["DIGITAL_AD_SPEC"] = "DIGITAL_AD_SPEC";
    EntityType["DIGITAL_AD_TYPE"] = "DIGITAL_AD_TYPE";
    EntityType["DIGITAL_PLACEMENT"] = "DIGITAL_PLACEMENT";
    EntityType["DIGITAL_CAMPAIGN_SUB_GROUP"] = "DIGITAL_CAMPAIGN_SUB_GROUP";
    EntityType["EXTERNAL_IDENTIFIER_TYPE"] = "EXTERNAL_IDENTIFIER_TYPE";
    EntityType["PRINT_CAMPAIGN_POSITION"] = "PRINT_CAMPAIGN_POSITION";
    EntityType["PRINT_AD_MEDIUM"] = "PRINT_AD_MEDIUM";
    EntityType["PRINT_AD_MEDIUM_MAPPING"] = "PRINT_AD_MEDIUM_MAPPING";
    EntityType["PRINT_AD_PRICE"] = "PRINT_AD_PRICE";
    EntityType["PRINT_AD_SPEC"] = "PRINT_AD_SPEC";
    EntityType["PRINT_AD_TYPE"] = "PRINT_AD_TYPE";
    EntityType["PRINT_PLACEMENT"] = "PRINT_PLACEMENT";
    EntityType["PRINT_CAMPAIGN_SUB_GROUP"] = "PRINT_CAMPAIGN_SUB_GROUP";
    EntityType["BROADCAST_CAMPAIGN_POSITION"] = "BROADCAST_CAMPAIGN_POSITION";
    EntityType["BROADCAST_AD_MEDIUM"] = "BROADCAST_AD_MEDIUM";
    EntityType["BROADCAST_AD_PRICE"] = "BROADCAST_AD_PRICE";
    EntityType["BROADCAST_AD_SPEC"] = "BROADCAST_AD_SPEC";
    EntityType["BROADCAST_AD_TYPE"] = "BROADCAST_AD_TYPE";
    EntityType["BROADCAST_PLACEMENT"] = "BROADCAST_PLACEMENT";
    EntityType["POINT_OF_SALE_CAMPAIGN_POSITION"] = "POINT_OF_SALE_CAMPAIGN_POSITION";
    EntityType["POINT_OF_SALE_AD_MEDIUM"] = "POINT_OF_SALE_AD_MEDIUM";
    EntityType["POINT_OF_SALE_AD_PRICE"] = "POINT_OF_SALE_AD_PRICE";
    EntityType["POINT_OF_SALE_AD_SPEC"] = "POINT_OF_SALE_AD_SPEC";
    EntityType["POINT_OF_SALE_AD_TYPE"] = "POINT_OF_SALE_AD_TYPE";
    EntityType["POINT_OF_SALE_CAMPAIGN_SUB_GROUP"] = "POINT_OF_SALE_CAMPAIGN_SUB_GROUP";
    EntityType["POINT_OF_SALE_PLACEMENT"] = "POINT_OF_SALE_PLACEMENT";
    EntityType["CONSULTING_AD_MEDIUM"] = "CONSULTING_AD_MEDIUM";
    EntityType["CONSULTING_AD_PRICE"] = "CONSULTING_AD_PRICE";
    EntityType["CONSULTING_AD_SPEC"] = "CONSULTING_AD_SPEC";
    EntityType["CONSULTING_AD_TYPE"] = "CONSULTING_AD_TYPE";
    EntityType["CONSULTING_AD_PLACEMENT"] = "CONSULTING_AD_PLACEMENT";
    EntityType["CONSULTING_CAMPAIGN_POSITION"] = "CONSULTING_CAMPAIGN_POSITION";
    EntityType["CONSULTING_CAMPAIGN_SUB_GROUP"] = "CONSULTING_CAMPAIGN_SUB_GROUP";
    EntityType["AD_SERVER_TECH_FEE"] = "AD_SERVER_TECH_FEE";
    EntityType["DELIVERY_DATA"] = "DELIVERY_DATA";
    EntityType["FORECAST"] = "FORECAST";
    EntityType["CAMPAIGN_POSITION_REVENUE_BY_DAY"] = "CAMPAIGN_POSITION_REVENUE_BY_DAY";
    EntityType["CAMPAIGN_POSITION_REVENUE_BY_WEBSITE"] = "CAMPAIGN_POSITION_REVENUE_BY_WEBSITE";
    EntityType["CAMPAIGN_POSITION_REVENUE_BY_CREATIVE"] = "CAMPAIGN_POSITION_REVENUE_BY_CREATIVE";
    EntityType["CONVERSION_TRACKER"] = "CONVERSION_TRACKER";
    EntityType["PAYOUT"] = "PAYOUT";
    EntityType["PAYOUT_WEBSITE"] = "PAYOUT_WEBSITE";
    EntityType["PAYOUT_CONFIG"] = "PAYOUT_CONFIG";
    EntityType["PAYOUT_MODIFICATION"] = "PAYOUT_MODIFICATION";
    EntityType["PAYOUT_MONTH_STATUS"] = "PAYOUT_MONTH_STATUS";
    EntityType["PAYOUT_PER_CAMPAIGN_POSITION"] = "PAYOUT_PER_CAMPAIGN_POSITION";
    EntityType["WEBSITE_GROUP"] = "WEBSITE_GROUP";
    EntityType["COMPANY_STATISTICS"] = "COMPANY_STATISTICS";
    EntityType["POSITION_GROUP"] = "POSITION_GROUP";
    EntityType["POSITION_GROUP_ENTRY"] = "POSITION_GROUP_ENTRY";
    EntityType["PUBLICATION_CALENDAR"] = "PUBLICATION_CALENDAR";
    EntityType["SIZE_CONFIG"] = "SIZE_CONFIG";
    EntityType["AVAILABILITY"] = "AVAILABILITY";
    EntityType["ADVERTISEMENT"] = "ADVERTISEMENT";
    EntityType["ADVERTISER"] = "ADVERTISER";
    EntityType["ADVERTISING_SPACE"] = "ADVERTISING_SPACE";
    EntityType["BRANCH_CLUSTER"] = "BRANCH_CLUSTER";
    EntityType["HISTORY_LOG"] = "HISTORY_LOG";
    EntityType["LABEL"] = "LABEL";
    EntityType["LABEL_EXTRACTION"] = "LABEL_EXTRACTION";
    EntityType["DISPATCH"] = "DISPATCH";
    EntityType["ADDRESSED_MAILING_POSITION"] = "ADDRESSED_MAILING_POSITION";
    EntityType["AD_UNIT"] = "AD_UNIT";
    EntityType["AD_UNIT_DETAILS"] = "AD_UNIT_DETAILS";
    EntityType["ADDRESSED_AD_UNIT_GROUP_DETAILS"] = "ADDRESSED_AD_UNIT_GROUP_DETAILS";
    EntityType["AUDIENCE_SEGMENT"] = "AUDIENCE_SEGMENT";
    EntityType["GOOGLE_LANGUAGE"] = "GOOGLE_LANGUAGE";
    EntityType["GOOGLE_LOCATION"] = "GOOGLE_LOCATION";
    EntityType["DIGITAL_POSITION"] = "DIGITAL_POSITION";
    EntityType["DISCOUNT_POSITION"] = "DISCOUNT_POSITION";
    EntityType["EMAIL_POSITION"] = "EMAIL_POSITION";
    EntityType["POST_INVOICE"] = "POST_INVOICE";
    EntityType["POST_INVOICE_POSITION"] = "POST_INVOICE_POSITION";
    EntityType["MAILING_POSITION"] = "MAILING_POSITION";
    EntityType["ONLINE_POSITION"] = "ONLINE_POSITION";
    EntityType["SERVICE_POSITION"] = "SERVICE_POSITION";
    EntityType["TARGET_GROUP"] = "TARGET_GROUP";
    EntityType["ADS_CONFIG"] = "ADS_CONFIG";
    EntityType["REPORTING_PAGE"] = "REPORTING_PAGE";
    EntityType["REPORTING_TEMPLATE"] = "REPORTING_TEMPLATE";
    EntityType["REPORTING_WIDGET"] = "REPORTING_WIDGET";
    EntityType["REPORTING_CAMPAIGN"] = "REPORTING_CAMPAIGN";
    EntityType["CAMPAIGN_REPORT"] = "CAMPAIGN_REPORT";
    EntityType["POSITION_REPORT"] = "POSITION_REPORT";
    EntityType["ACTIVITY"] = "ACTIVITY";
    EntityType["SELFBOOKED_CAMPAIGN_HISTORY"] = "SELFBOOKED_CAMPAIGN_HISTORY";
    EntityType["ACCOUNT_HISTORY"] = "ACCOUNT_HISTORY";
    EntityType["COMMENT"] = "COMMENT";
    EntityType["KEYWORD_GROUP_DEFAULTS"] = "KEYWORD_GROUP_DEFAULTS";
    EntityType["KEYWORD_GROUP_HISTORY"] = "KEYWORD_GROUP_HISTORY";
    EntityType["KEYWORD_GROUP"] = "KEYWORD_GROUP";
    EntityType["ACCOUNT_DIFF"] = "ACCOUNT_DIFF";
    EntityType["INVOICE_CHARGE"] = "INVOICE_CHARGE";
    EntityType["POSITION_DIFF"] = "POSITION_DIFF";
    EntityType["PRICE_DIFF"] = "PRICE_DIFF";
    EntityType["COOP_WEEK"] = "COOP_WEEK";
    EntityType["COMPANY_CONFIG"] = "COMPANY_CONFIG";
    EntityType["CREDIT_CARD"] = "CREDIT_CARD";
    EntityType["STRIPE_PAYMENT"] = "STRIPE_PAYMENT";
    EntityType["STRIPE_PAYOUT"] = "STRIPE_PAYOUT";
    EntityType["ARTICLE"] = "ARTICLE";
    EntityType["CRAWLER_CONFIG"] = "CRAWLER_CONFIG";
    EntityType["CRAWLER_PATH_CONFIG"] = "CRAWLER_PATH_CONFIG";
    EntityType["CRAWLER_PATH_POSITION"] = "CRAWLER_PATH_POSITION";
    EntityType["CRAWLER_PATH_TEMPLATE"] = "CRAWLER_PATH_TEMPLATE";
    EntityType["ACCOUNT_EMAIL"] = "ACCOUNT_EMAIL";
    EntityType["ACCOUNT_EMAIL_ATTACHMENT"] = "ACCOUNT_EMAIL_ATTACHMENT";
    EntityType["ACCOUNT_TYPE"] = "ACCOUNT_TYPE";
    EntityType["SYNCHRONIZED_USER"] = "SYNCHRONIZED_USER";
    EntityType["COMPANY_SYNC_SETTINGS"] = "COMPANY_SYNC_SETTINGS";
    EntityType["STOCK_ENTRY"] = "STOCK_ENTRY";
    EntityType["IMPORTS"] = "IMPORTS";
    EntityType["PRINT_CREATIVE"] = "PRINT_CREATIVE";
    EntityType["PRINT_CAMPAIGN_POSITION_EXPORT"] = "PRINT_CAMPAIGN_POSITION_EXPORT";
    EntityType["PUBLICATION"] = "PUBLICATION";
    EntityType["SCREENSHOT"] = "SCREENSHOT";
    EntityType["SCREENSHOT_CAMPAIGN"] = "SCREENSHOT_CAMPAIGN";
    EntityType["SCREENSHOT_DIGITAL_CAMPAIGN_POSITION"] = "SCREENSHOT_DIGITAL_CAMPAIGN_POSITION";
    EntityType["DIGITAL_CREATIVE"] = "DIGITAL_CREATIVE";
    EntityType["DIGITAL_CREATIVE_UPLOAD"] = "DIGITAL_CREATIVE_UPLOAD";
    EntityType["FORM_TEMPLATE"] = "FORM_TEMPLATE";
    EntityType["FORM_TEMPLATE_LEAD"] = "FORM_TEMPLATE_LEAD";
    EntityType["MEETING"] = "MEETING";
    EntityType["PROMOTION_MAIL_TEMPLATE"] = "PROMOTION_MAIL_TEMPLATE";
    EntityType["SALES_PROMOTION"] = "SALES_PROMOTION";
    EntityType["SALES_PROMOTION_ACCOUNT"] = "SALES_PROMOTION_ACCOUNT";
    EntityType["SALES_PROMOTION_CONTACT"] = "SALES_PROMOTION_CONTACT";
    EntityType["SALES_PROMOTION_TYPE_CONFIG"] = "SALES_PROMOTION_TYPE_CONFIG";
    EntityType["SOURCE"] = "SOURCE";
    EntityType["TASK"] = "TASK";
    EntityType["TASK_TOPIC"] = "TASK_TOPIC";
    EntityType["TOPIC"] = "TOPIC";
    EntityType["TOPIC_DISCUSSION"] = "TOPIC_DISCUSSION";
    EntityType["DIGITAL_CAMPAIGN_POSITION_CHECK"] = "DIGITAL_CAMPAIGN_POSITION_CHECK";
    EntityType["WEBSITE_MAPPING"] = "WEBSITE_MAPPING";
    EntityType["POSTNETZ_DOCUMENT"] = "POSTNETZ_DOCUMENT";
    EntityType["COMMON_AD_MEDIUM"] = "COMMON_AD_MEDIUM";
    EntityType["COMMON_AD_TYPE"] = "COMMON_AD_TYPE";
    EntityType["COMMON_PLACEMENT"] = "COMMON_PLACEMENT";
    EntityType["DISCOUNT"] = "DISCOUNT";
    EntityType["DISCOUNT_DETAIL"] = "DISCOUNT_DETAIL";
    EntityType["INVOICE"] = "INVOICE";
    EntityType["INVOICE_COMPANY_CONFIG"] = "INVOICE_COMPANY_CONFIG";
    EntityType["INVOICE_POSITION"] = "INVOICE_POSITION";
    EntityType["INVOICE_PAYMENT"] = "INVOICE_PAYMENT";
    EntityType["PINGEN_LETTER"] = "PINGEN_LETTER";
    EntityType["AD_MANAGER_REVENUE"] = "AD_MANAGER_REVENUE";
    EntityType["BRAND_COMPANY_CONFIG"] = "BRAND_COMPANY_CONFIG";
    EntityType["DEAL_COMPANY_CONFIG"] = "DEAL_COMPANY_CONFIG";
    EntityType["SSP_REVENUE_CONFIG"] = "SSP_REVENUE_CONFIG";
    EntityType["SSP_CAMPAIGN"] = "SSP_CAMPAIGN";
    EntityType["SSP_CAMPAIGN_POSITION"] = "SSP_CAMPAIGN_POSITION";
    EntityType["SSP_DELIVERY_DATA_PER_DAY"] = "SSP_DELIVERY_DATA_PER_DAY";
    EntityType["AD_SENSE_TAG_TEMPLATE"] = "AD_SENSE_TAG_TEMPLATE";
    EntityType["AD_SENSE_TEMPLATE"] = "AD_SENSE_TEMPLATE";
    EntityType["AD_TAG"] = "AD_TAG";
    EntityType["PARAMETERS_MEDIATION"] = "PARAMETERS_MEDIATION";
    EntityType["PLACEMENT_MEDIATION"] = "PLACEMENT_MEDIATION";
    EntityType["AMAZON_TEMPLATE"] = "AMAZON_TEMPLATE";
    EntityType["C_WIRE_TEMPLATE"] = "C_WIRE_TEMPLATE";
    EntityType["DEPARTMENT_CONFIG"] = "DEPARTMENT_CONFIG";
    EntityType["DEPARTMENT_CONFIGS_SIZE_MAPPING"] = "DEPARTMENT_CONFIGS_SIZE_MAPPING";
    EntityType["DISABLE_RULE"] = "DISABLE_RULE";
    EntityType["DYNAMIC_PLACEMENT"] = "DYNAMIC_PLACEMENT";
    EntityType["IX_TEMPLATE"] = "IX_TEMPLATE";
    EntityType["HEADER_TAG_PLACEMENT"] = "HEADER_TAG_PLACEMENT";
    EntityType["RAW_SCRIPT"] = "RAW_SCRIPT";
    EntityType["SIZE"] = "SIZE";
    EntityType["SIZE_MAPPING"] = "SIZE_MAPPING";
    EntityType["TAG"] = "TAG";
    EntityType["APP_NEXUS_REVENUE"] = "APP_NEXUS_REVENUE";
    EntityType["XANDR_CREATIVE"] = "XANDR_CREATIVE";
    EntityType["GAM_CREATIVE"] = "GAM_CREATIVE";
    EntityType["DSP_DELIVERY_DATA"] = "DSP_DELIVERY_DATA";
    EntityType["DSP_DELIVERY_DATA_PER_CREATIVE"] = "DSP_DELIVERY_DATA_PER_CREATIVE";
    EntityType["DSP_DELIVERY_DATA_PER_SITE"] = "DSP_DELIVERY_DATA_PER_SITE";
    EntityType["DSP_DELIVERY_DATA_PER_SITE_PER_DAY"] = "DSP_DELIVERY_DATA_PER_SITE_PER_DAY";
    EntityType["DSP_DELIVERY_DATA_PER_SIZE"] = "DSP_DELIVERY_DATA_PER_SIZE";
    EntityType["LINE_ITEM"] = "LINE_ITEM";
    EntityType["PUBLISHER"] = "PUBLISHER";
    EntityType["BRAND_REVENUE"] = "BRAND_REVENUE";
    EntityType["DEAL_REVENUE"] = "DEAL_REVENUE";
    EntityType["LINE_ITEM_SERVICE_RESULT"] = "LINE_ITEM_SERVICE_RESULT";
    EntityType["TAG_DEPARTMENT_CONFIG"] = "TAG_DEPARTMENT_CONFIG";
    EntityType["TAG_PARAMETER"] = "TAG_PARAMETER";
    EntityType["TEADS_TEMPLATE"] = "TEADS_TEMPLATE";
    EntityType["XANDER_BANNER_TEMPLATE"] = "XANDER_BANNER_TEMPLATE";
    EntityType["AD_SENSE_BIDDER_CONFIG"] = "AD_SENSE_BIDDER_CONFIG";
    EntityType["AMAZON_BIDDER_CONFIG"] = "AMAZON_BIDDER_CONFIG";
    EntityType["BIDDER_CONFIG"] = "BIDDER_CONFIG";
    EntityType["DEFAULT_BIDDER_CONFIG"] = "DEFAULT_BIDDER_CONFIG";
    EntityType["FLOOR_RULE"] = "FLOOR_RULE";
    EntityType["FLOOR_RULE_ENTRY"] = "FLOOR_RULE_ENTRY";
    EntityType["GOOGLE_BIDDER_CONFIG"] = "GOOGLE_BIDDER_CONFIG";
    EntityType["HEADER_TAG"] = "HEADER_TAG";
    EntityType["HEADER_TAG_BIDDER"] = "HEADER_TAG_BIDDER";
    EntityType["HEADER_TAG_BIDDER_SUPPLY_CHAIN"] = "HEADER_TAG_BIDDER_SUPPLY_CHAIN";
    EntityType["HEADER_TAG_RAW_SCRIPT"] = "HEADER_TAG_RAW_SCRIPT";
    EntityType["HEADER_TAG_PLACEMENT_BIDDER"] = "HEADER_TAG_PLACEMENT_BIDDER";
    EntityType["SERVER_SIDE_BIDDER_CONFIG"] = "SERVER_SIDE_BIDDER_CONFIG";
    EntityType["SUPPLY_CHAIN"] = "SUPPLY_CHAIN";
    EntityType["SDK_GLOBAL_CONFIG"] = "SDK_GLOBAL_CONFIG";
    EntityType["SDK_AD_CONFIG"] = "SDK_AD_CONFIG";
    EntityType["SDK_PUBLISHER"] = "SDK_PUBLISHER";
    EntityType["TICKET"] = "TICKET";
    EntityType["TICKET_ACTIVITY"] = "TICKET_ACTIVITY";
    EntityType["INVOICE_INFO"] = "INVOICE_INFO";
    EntityType["COMPANY_MAIL_TEMPLATE"] = "COMPANY_MAIL_TEMPLATE";
    EntityType["EMAIL_DESIGN"] = "EMAIL_DESIGN";
    EntityType["COMPANY_PDF_FOOTER_TEMPLATE"] = "COMPANY_PDF_FOOTER_TEMPLATE";
    EntityType["PDF_STYLE"] = "PDF_STYLE";
    EntityType["ROW_CONFIG"] = "ROW_CONFIG";
    EntityType["PDF_TYPE_CONFIG"] = "PDF_TYPE_CONFIG";
    EntityType["ADS_BLOCK"] = "ADS_BLOCK";
    EntityType["ADS_ENTRY"] = "ADS_ENTRY";
    EntityType["REFERENCE_LIST"] = "REFERENCE_LIST";
    EntityType["POST_DOCUMENT_METADATA"] = "POST_DOCUMENT_METADATA";
    EntityType["COMPANY_NOTIFICATION"] = "COMPANY_NOTIFICATION";
    EntityType["ACCOUNTING_INFO"] = "ACCOUNTING_INFO";
    EntityType["COMPANY_DISCOUNT"] = "COMPANY_DISCOUNT";
    EntityType["PPT_STYLE"] = "PPT_STYLE";
    EntityType["PPT_COMMENT_TEMPLATE"] = "PPT_COMMENT_TEMPLATE";
    EntityType["CUSTOM_INVOICE_ID_RANGE"] = "CUSTOM_INVOICE_ID_RANGE";
    EntityType["SELFBOOKING_ADVERTISER"] = "SELFBOOKING_ADVERTISER";
    EntityType["BALANCE_RECORD"] = "BALANCE_RECORD";
    EntityType["SELFBOOKING_CAMPAIGN"] = "SELFBOOKING_CAMPAIGN";
    EntityType["SELFBOOKING_SSP_CAMPAIGN"] = "SELFBOOKING_SSP_CAMPAIGN";
    EntityType["SELFBOOKING_CAMPAIGN_POSITION"] = "SELFBOOKING_CAMPAIGN_POSITION";
    EntityType["SELFBOOKING_SSP_CAMPAIGN_POSITION"] = "SELFBOOKING_SSP_CAMPAIGN_POSITION";
    EntityType["SELFBOOKING_CONVERSION_TRACKER"] = "SELFBOOKING_CONVERSION_TRACKER";
    EntityType["SELFBOOKING_CREATIVE"] = "SELFBOOKING_CREATIVE";
    EntityType["SELFBOOKING_DELIVERY_DATA"] = "SELFBOOKING_DELIVERY_DATA";
    EntityType["SELFBOOKING_DELIVERY_DATA_PER_CREATIVE"] = "SELFBOOKING_DELIVERY_DATA_PER_CREATIVE";
    EntityType["SELFBOOKING_SSP_DELIVERY_DATA"] = "SELFBOOKING_SSP_DELIVERY_DATA";
    EntityType["SELFBOOKING_DOCUMENT"] = "SELFBOOKING_DOCUMENT";
    EntityType["SELFBOOKING_INVOICE"] = "SELFBOOKING_INVOICE";
    EntityType["SELFBOOKING_INVOICE_POSITION"] = "SELFBOOKING_INVOICE_POSITION";
    EntityType["SELFBOOKING_WEBSITE"] = "SELFBOOKING_WEBSITE";
    EntityType["SELFBOOKING_CAMPAIGN_POSITION_HISTORY"] = "SELFBOOKING_CAMPAIGN_POSITION_HISTORY";
    EntityType["SELFBOOKING_CAMPAIGN_POSITION_PRICE_HISTORY"] = "SELFBOOKING_CAMPAIGN_POSITION_PRICE_HISTORY";
    EntityType["SELFBOOKING_ACTIVITY"] = "SELFBOOKING_ACTIVITY";
    EntityType["CUSTOM_PAYOUT_ID_RANGE"] = "CUSTOM_PAYOUT_ID_RANGE";
    EntityType["TEMPORARY_ACCESS"] = "TEMPORARY_ACCESS";
    EntityType["LOCKED_FIELDS_CONFIG"] = "LOCKED_FIELDS_CONFIG";
})(EntityType || (EntityType = {}));
